import { elsterDocxUtils, emptyLine } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import generalTable from '../utils/generalTable';
import { grayTitlesMain } from '../styles/elsterDocStyles';
import { IORADO_PROJECTS_FIVE_VERSION_8, IORADO_PROJECTS_FIVE_VERSION_7 } from '../constants/elsterDocxConstants';
const shareholders = (shareholdersList, isVersion8, mainParagraphOptions) => {
  const {
    t
  } = i18n;
  const {
    createTextRunInParagraph
  } = elsterDocxUtils;
  const tableInstructions = isVersion8 ? IORADO_PROJECTS_FIVE_VERSION_8 : IORADO_PROJECTS_FIVE_VERSION_7;
  if (!Array.isArray(shareholdersList) || shareholdersList.length === 0) {
    return [createTextRunInParagraph(t('iorado_own_cont_by_shareholders'), grayTitlesMain, mainParagraphOptions), generalTable({}, tableInstructions)];
  }
  return shareholdersList.flatMap(shareholder => [createTextRunInParagraph(t('iorado_own_cont_by_shareholders'), grayTitlesMain, mainParagraphOptions), generalTable(shareholder, tableInstructions), emptyLine]);
};
export default shareholders;